import { render, staticRenderFns } from "./trafficPermitLv.vue?vue&type=template&id=5060a259&"
import script from "./trafficPermitLv.vue?vue&type=script&lang=js&"
export * from "./trafficPermitLv.vue?vue&type=script&lang=js&"
import style0 from "./trafficPermitLv.vue?vue&type=style&index=0&id=5060a259&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports